import React, { Component } from 'react';
import { Button, FormControl } from 'react-bootstrap';
import "./VasMiles.css"

interface VasMilesProps {
    appendParams: Function
    searchParams: Object

}

type VasMilesTypes = {
    StartMileage: string
    EndMileage: string
    eventType: string
}

class VasMiles extends Component<VasMilesProps, VasMilesTypes> {

    state = {
        StartMileage: "",
        EndMileage: "",
        eventType: ""
    }

    componentDidMount() {
        let param: any = this.props.searchParams
        this.setState({ StartMileage: param.StartMileage, EndMileage: param.EndMileage })
    }

    setEventType = (eventType: string) => {
        this.setState({ eventType: eventType })
    }

    handleChange = (event: { target: { value: any } }) => {
        let str = event.target.value.replace(/,/g, '')
        if (str.length < 7) {
            if (!isNaN(str)) {
                if (parseInt(str) < 0) {
                    str = 0 + ""
                }
                const eventTypes = Object.keys(this.state)
                for (let i = 0; i < eventTypes.length; i++) {
                    if (this.state.eventType === eventTypes[i]) {
                        const param: object = { [eventTypes[i]]: str }
                        this.setState(param)
                        this.props.appendParams([param])
                    }
                }
            }
        }
    }

    clearForm = (propertyName: string) => {
        this.setState({ [propertyName]: "" } as Pick<VasMilesTypes, keyof VasMilesTypes>)
        this.props.appendParams([{ [propertyName]: "" }])
    }

    render() {

        return (
            <div className="VAS-Miles">
                <div className="VAS-Miles-Input-Wrapper">
                    <div className="VAS-Miles-Start-Wrapper" >
                        <div className="VAS-Miles-Start-Input-Wrapper">
                            <FormControl
                                onFocus={() => this.setEventType("StartMileage")}
                                placeholder={"Minimum Mileage"}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.StartMileage.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""}
                            />
                            {this.state.StartMileage.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("StartMileage")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>}
                        </div>
                    </div>
                    <div className="VAS-Miles-End-Wrapper" >
                        <div className="VAS-Miles-End-Input-Wrapper">
                            <FormControl
                                onFocus={() => this.setEventType("EndMileage")}
                                placeholder={"Maximum Mileage"}
                                aria-label="Username"
                                aria-describedby="basic-addon1"
                                onChange={this.handleChange}
                                value={this.state.EndMileage.replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ""}
                            />
                            {this.state.EndMileage.length > 0 && <Button id="vas-clear-param-btn-input" tabIndex={-1} onClick={() => this.clearForm("EndMileage")}>
                                <span id="vas-clear-x-btn" className="material-icons">
                                    close
                                </span>
                            </Button>}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default VasMiles